import { createAction } from 'redux-actions';

export const QUESTS_ACTIONS = {
    ADVANCE_STEP: 'quests advance step',
    COMPLETE_QUEST: 'quests complete quest',
    INCREMENT_COUNTER: 'quests increment counter',
    INIT: 'quests init',
};

export const questsActions = {
    init: createAction(QUESTS_ACTIONS.INIT),
    advanceStep: createAction(QUESTS_ACTIONS.ADVANCE_STEP, (questId, nextStep) => ({ questId, nextStep })),
    completeQuest: createAction(QUESTS_ACTIONS.COMPLETE_QUEST, (questId) => ({ questId })),
    incrementCounter: createAction(QUESTS_ACTIONS.INCREMENT_COUNTER, (questId, counterKey, by) => ({ questId, counterKey, by })),
};
